import { useQuery } from '@hooks/reactQuery';

import { map } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getAssetById } from '@api/map';

import { ASSETS } from '@constants/queryKeys';

export const useQueryActiveAssetsData = () => {
	const { activeAssetMarkers } = useAppSelector(map);

	const {
		data: activeAssets,
		isInitialLoading,
	} = useQuery<any>({
		queryKey: [ASSETS, activeAssetMarkers],
		queryFn: () => Promise.all(activeAssetMarkers.map(id => getAssetById(id))),
		enabled: [!!activeAssetMarkers?.length],
		refetchOnWindowFocus: false,
	});

	return {
		activeAssets,
		isLoadingActiveAssetsData: isInitialLoading,
	};
};
